<template>
  <li
    class="main-item point"
    @click="$emit('changeActiveComponent')"
  >
    <a
      class="main-item-link point"
      :class="{ active: isActive }"
    >
      Browse by District
      <img
        class="icon"
        src="../../../images/down-arrow.svg"
        alt=""
      >
    </a>

    <ul
      class="sub-list hide"
      :class="{ show: isActive }"
    >
      <li
        v-for="district in districts"
        :key="district.id"
        class="sub-list-item"
      >
        <router-link
          :to="`/lawyer-list?district=${district.city}`"
          class="name"
        >
          {{ district.city }}
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import {computed, onMounted} from 'vue'
import {useDistrictStore} from '@/store'
import {useHead} from '@unhead/vue'
import {watchEffect} from 'vue'

export default {
  name: 'BrowseByCity',
  props: {
    active: {
      type: String,
      default: 'ByName',
    },
  },

  setup(props) {
    const districtStore = useDistrictStore()

    watchEffect(
      async () => await districtStore.getAllDistricts(),
    )

    onMounted(async () => {
      await districtStore.getAllDistricts()
    })

    const districts = computed(() => districtStore.allDistricts)

    const isActive = computed(() => props.active === 'ByCity')

    const districtNameList = districts.value.map((district) => district.city)

    useHead({
      meta: [
        {
      name: 'keywords', content: () => `Professional Services, Free legal question answer,
        Company Registration and compliances, IRD Registration,
        Share Lagat, Company Amendment, Annual Reporting and Filing,
        Rental Agreements, Lease Agreement, Service Agreements,
        Contracts (personal and Professional), Design, Patent,
        Trademark Registration, Copyright, Intellectual Property,
        Deregistration, Liquidation, Social Welfare Council registration, Exim Code,
        Department Registration, Foreign Direct investment, Corporate
        Conversions, Law related Events and trainings, Legal Technology Company in Nepal,
        Tax, VAT, PAN, Lawyer, Advocate, Law, Nepal,
        Lawyer Near me, Legal Education, Literacy, Find a Lawyer,
        Legal Marketplace, Non Resident Nepali Services, NRN. ${districtNameList.toString().split(',').join(', ')}`,
        }],
    })

    return {
      isActive,
      districts,
    }
  },
}
</script>

<style lang="scss" scoped>
.sub-list {
  max-height: 350px;
  margin: 1rem 0;
  overflow-y: auto;
  padding: 0 2rem;

  .sub-list-item {
    margin-bottom: 0;
    float: left;
    width: calc(100% / 4);
    padding-right: 30px;

    .name {
      margin: 10px 0 0;
    }
  }
}
@media (max-width: 767px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 2);
    }
  }
}
@media (max-width: 499px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 2);
    }
  }
}
@media (max-width: 400px) {
  .sub-list {
    .sub-list-item {
      width: calc(100% / 1);
      padding-right: 0;
    }
  }
}
</style>
